import * as React from 'react';

export const BreadcrumbsContext = React.createContext<{
    isCurrent?: boolean;
}>(null);
